module.exports = __webpack_public_path__ + "static/img/lb2.53ce07d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/lb2.png
// module id = wTai
// module chunks = 0